"use strict";

import IMask from 'imask';
import {onFind} from "@elements/init-modules-in-scope";

export function init () {
    onFind('.js-keycard', function(baseElement) {
         let maskOptions = {
             mask: baseElement.getAttribute('data-keycard-pattern')
         };

         IMask(baseElement, maskOptions);
    })
}